import ActivityTab from './ActivityTab'

export default ActivityTab
